/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   Homepage selectors
 */

import uniqueListables from '@zcode/nr/es/shared/utils/uniqueListables'
import type { Listables, State } from '@zcode/state-type'
import { compose } from 'redux'

export const selectHomePage = (state: State) => state.homepage

const combinedUniqueListables = (listablesObj: Listables | null) => {
  if (!listablesObj) {
    return
  }

  const featured = listablesObj.featured
  const listables = listablesObj.listables

  return uniqueListables(featured?.length ? featured.concat(listables) : listables)
}

export const selectListables = (state: State) => {
  return combinedUniqueListables(state.homepage.listables)
}

export const selectNewListables = (state: State) => {
  return combinedUniqueListables(state.homepage.newListables)
}

export const selectPetListables = (state: State) => {
  return combinedUniqueListables(state.homepage.petListables)
}

export const selectLuxuryListables = (state: State) => {
  return combinedUniqueListables(state.homepage.luxuryListables)
}

export const selectUtilitiesIncludedListables = (state: State) => {
  return combinedUniqueListables(state.homepage.utilitiesIncludedListables)
}

export const selectSpotlightListables = (state: State) => {
  return state.homepage.spotlightListables
}

export const hasListables = (state: State) => {
  const listables = selectListables(state)
  const newListables = selectNewListables(state)
  const petListables = selectPetListables(state)

  return !!listables?.length || !!newListables?.length || !!petListables?.length
}

export const hasListablesZumperRentals = (state: State) => {
  const petListables = selectPetListables(state)
  const luxuryListables = selectLuxuryListables(state)
  const utilitiesIncludedListables = selectUtilitiesIncludedListables(state)

  return !!petListables?.length || !!luxuryListables?.length || !!utilitiesIncludedListables?.length
}

export const selectIsListablesLoading = compose((hp) => hp.isListablesLoading, selectHomePage)
export const selectIsSpotlightListablesLoading = compose(
  (hp) => hp.isSpotlightListablesLoading,
  selectHomePage
)

export const selectAddressLinks = compose((hp) => hp.addressLinks, selectHomePage)

export const selectAreAddressLinksLoaded = compose((hp) => {
  return hp.addressLinksLoaded
}, selectHomePage)

export const selectBuildingLinks = compose((hp) => hp.buildingLinks, selectHomePage)

export const selectAreBuildingLinksLoaded = compose((hp) => {
  return hp.buildingLinksLoaded
}, selectHomePage)
